import { createContext, useContext } from "react";
const DocumentContext = createContext(null);
function useDocumentKey() {
  return useContext(DocumentContext);
}
export {
  DocumentContext,
  useDocumentKey
};
//# sourceMappingURL=use-document-key.js.map